var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('SideMenu'),_c('NavMenu'),_c('v-main',{style:(("margin-left:" + _vm.mainMargin + "px"))},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }